"use strict";
/* eslint-disable @typescript-eslint/no-unused-vars */

'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transition = void 0;
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["in", "onEnter", "onExited", "type", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var classNames = {
  fade: {
    appear: 'opacity-0',
    appearActive: '!opacity-100 transition-opacity duration-300 ease-out',
    exit: 'opacity-100',
    exitActive: '!opacity-0 transition-opacity duration-200 ease-in'
  },
  grow: {
    appear: 'opacity-0 scale-95',
    appearActive: '!opacity-100 !scale-100 transition-all duration-300 ease-out',
    exit: 'opacity-100 scale-100',
    exitActive: '!opacity-0 !scale-95 transition-all duration-200 ease-in'
  },
  'slide-right': {
    appear: 'opacity-0 -translate-x-96',
    appearActive: '!opacity-100 !translate-x-0 transition-all duration-300 ease-out',
    exit: 'opacity-100 translate-x-0',
    exitActive: '!opacity-0 !-translate-x-96 transition-all duration-200 ease-in'
  },
  'slide-left': {
    appear: 'opacity-0 translate-x-96',
    appearActive: '!opacity-100 !translate-x-0 transition-all duration-300 ease-out',
    exit: 'opacity-100 translate-x-0',
    exitActive: '!opacity-0 !translate-x-96 transition-all duration-200 ease-in'
  }
};

/**
 * Transition - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/utils-transition)
 */
var Transition = exports.Transition = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$in = _ref["in"],
    inProp = _ref$in === void 0 ? false : _ref$in,
    onEnter = _ref.onEnter,
    onExited = _ref.onExited,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'fade' : _ref$type,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var nodeRef = (0, _react.useRef)(null);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTransitionGroup.CSSTransition, _objectSpread(_objectSpread({}, props), {}, {
    "in": inProp,
    appear: true,
    nodeRef: nodeRef,
    onEnter: onEnter,
    onExited: onExited,
    timeout: {
      appear: 300,
      exit: 200
    },
    classNames: classNames[type],
    unmountOnExit: true,
    children: /*#__PURE__*/(0, _react.cloneElement)(children, {
      ref: nodeRef
    })
  }));
});